import type { NavigateFunction } from 'react-router';

import { appPath } from '@/AppRouter';

export const handleAuthNavigation = ({
  authenticated,
  cookiesAccepted,
  login,
  navigate,
}: {
  authenticated: boolean | undefined;
  cookiesAccepted: boolean;
  login: () => void;
  navigate: NavigateFunction;
}) => {
  if (!cookiesAccepted) return;
  if (authenticated) {
    navigate(`${appPath}account`);
  } else {
    login();
  }
};
